export default "__VITE_ASSET__8dbc07a1__"